import * as sagaEffects from 'redux-saga/effects';

import handleListenLastImportSaga from './handleListenLastImportSaga';
import handleUnlistenLastImportSaga from './handleUnlistenLastImportSaga';
import handleListenLogsSaga from './handleListenLogsSaga';
import handleUnlistenLogsSaga from './handleUnlistenLogsSaga';
import handleDispatchImportSaga from './handleDispatchImportSaga';

import handleListenerResponseSaga from './handleListenerResponseSaga';

const { all } = sagaEffects;

export default function* () {
    yield all([
        handleListenLastImportSaga(),
        handleUnlistenLastImportSaga(),
        handleListenLogsSaga(),
        handleUnlistenLogsSaga(),
        handleDispatchImportSaga(),
        handleListenerResponseSaga(),
    ]);
}
